import React from 'react'
import { Box } from '@mui/material'
import TopBar from "../../../../../../component/TopBar"
import MainBox from "../../../../container/MainBox"
import EditPolicy from '../../../../../../component/edit-policy/index'

const ExpensePolicyEdit = () => {
  return (
    <Box sx={{ width: "100%" }}>
      <TopBar MainHeading={"Expense Policy"} breadcrumbs={[{ label: "Expense Policy", href: "/app/expense-policy/listing" }, { label: "Edit" }]} />
      <MainBox sx={{ padding: "2rem 1.25rem" }}>
        <EditPolicy type="ANY" />
      </MainBox>
    </Box>
  )
}

export default ExpensePolicyEdit
